import { isPlainObject } from '@hub/common';
import { FirebaseError } from 'firebase/app';
import { ApplicationError } from './ApplicationError';

export const convertToApplicationError = (error: unknown): ApplicationError => {
  if (error instanceof ApplicationError) {
    return error;
  } else {
    const unknownError = new ApplicationError('PHW-X-001');
    unknownError.cause = error;
    return unknownError;
  }
};

export const errorCode = (error: unknown): string | undefined => {
  const { code } = (error ?? {}) as { code?: unknown };
  return typeof code === 'string' ? code : undefined;
};

export const errorDetails = (
  error: unknown
): Record<string, unknown> | undefined => {
  const { details } = (error ?? {}) as { details?: unknown };
  return isPlainObject(details) ? details : undefined;
};

export const errorReason = (error: unknown): unknown =>
  errorDetails(error)?.['reason'];

export const callableErrorDetails = (
  error: unknown
): {
  code: string | undefined;
  httpStatus?: number;
  server?: Record<string, unknown>;
} => {
  const code = errorCode(error);
  const isCallable = code?.startsWith('functions/') ?? false;
  const { message, details } = (error ?? {}) as {
    message?: unknown;
    details?: unknown;
  };
  const match =
    isCallable && typeof message === 'string'
      ? /\[(\d+)\]$/.exec(message)
      : null;
  return {
    code,
    ...(match && { httpStatus: Number(match[1]) }),
    ...(isCallable && isPlainObject(details) && { server: details }),
  };
};

export const isFirebasePermissionDeniedError = (
  error: unknown
): error is FirebaseError =>
  error instanceof FirebaseError && error.code === 'permission-denied';
